
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import VibemailLogo from '@/components/VibemailLogo';
import { Button } from "@/components/ui/button";
import { Plus } from 'lucide-react';
import { emitNewConversation } from '@/lib/eventHandlers';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isBuilderPage = window.location.pathname.includes('/builder');
  
  const handleNewChat = () => {
    console.log("Header: New chat button clicked");
    emitNewConversation();
    if (!isBuilderPage) {
      navigate('/builder');
    }
  };
  
  // For builder page, show a minimal header with just new chat button
  if (isBuilderPage && user) {
    return (
      <header className="fixed top-0 right-0 p-4 z-40">
        <Button 
          variant="outline" 
          size="sm"
          onClick={handleNewChat}
          className="bg-black/60 border-jade/20 hover:bg-black hover:border-jade/40"
        >
          <Plus className="mr-1 h-4 w-4" />
          Neue Konversation
        </Button>
      </header>
    );
  }
  
  // Hide header completely for other pages when user is logged in
  if (user) {
    return null;
  }
  
  // Show logo and login/signup buttons for non-authenticated users
  return (
    <header className="fixed top-0 left-0 right-0 p-4 z-50 flex justify-between items-center">
      <div className="flex items-center">
        <VibemailLogo />
      </div>
      <div className="flex items-center space-x-2">
        <Button 
          variant="outline" 
          onClick={() => navigate('/auth')}
          className="code-button"
        >
          Anmelden
        </Button>
        <Button 
          variant="default" 
          onClick={() => navigate('/auth')}
        >
          Registrieren
        </Button>
      </div>
    </header>
  );
};

export default Header;
